/* istanbul ignore file */
import { validationRules } from '@/utils';

const guarantosFormValidationSchema = {
  name: validationRules.isOnlyText,
  marital_status: validationRules.requiredfield,
  degree_of_relatedness: validationRules.requiredfield,
  degree_of_relatedness_other: validationRules.relatednessOtherIsRequired,
  marital_regime: validationRules.requiredPropertyRegime,
  email: validationRules.requiredEmail,
  phone_number: validationRules.requiredPhoneNumber,
  day: validationRules.validateBirthDate,
  month: validationRules.requiredfield,
  year: validationRules.requiredfield,
  nationality: validationRules.requiredfield,
  nationalityOther: validationRules.nationalityOtherIsRequired,
  birthplace: validationRules.requiredfield,
  zipcode: validationRules.requiredfield,
  state: validationRules.stateValueIsValid,
  city: validationRules.requiredfield,
  neighborhood: validationRules.requiredfield,
  address: validationRules.requiredfield,
  residence_type: validationRules.requiredfield,
  residence_number: validationRules.requiredfield,
  address_complement: validationRules.complementIsWithinCharLimit,
  cpf: validationRules.requiredCpf,
  rg: validationRules.requiredfield,
  rg_issuing_body: validationRules.requiredfield,
  rg_issuing_state: validationRules.requiredfield,
  pep: validationRules.requiredfield,
  proofOfAddress: validationRules.requiredFile,
  cpfFile: validationRules.requiredFile,
  rgFile: validationRules.requiredFile,
  selfieWithDocument: validationRules.requiredFile,
};

export default guarantosFormValidationSchema;
